<template>
  <div v-show="_items.length>0" >
      <!-- Profile dropdown -->
            <Menu as="div" class="relative">
              <MenuButton class="-m-1.5 flex items-center p-1.5">
                <UserCircleIcon class="h-8 w-8 text-gray-400"/>

                <span class="hidden lg:flex lg:items-center">
                  <span class="ml-4 text-sm font-semibold leading-6 text-gray-900" aria-hidden="true">{{ _welcomeMessage }}</span>
                  <ChevronDownIcon class="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
              </MenuButton>

              <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">

                <MenuItems class="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">

                  <MenuItem v-for="item in _items" :key="item.name" v-slot="{ active }">
                    <a @click="item?.onClick()" :href="item.link" :class="[active ? 'bg-gray-50' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900']">{{ item.name }}</a>

                  </MenuItem>

                </MenuItems>
              </transition>

            </Menu>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUpdated, } from "vue";

import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
} from "@headlessui/vue";

import { ChevronDownIcon, UserCircleIcon, } from "@heroicons/vue/20/solid";

const _items = ref([]);
const _welcomeMessage = ref("");

const props = defineProps<{
  userNavigation: Array; // Expects array of objects containing link, name current and icon
  welcomeMessage: string;
}>();

onMounted(() => {
  _items.value = props.userNavigation;
  _welcomeMessage.value = props.welcomeMessage;
});

</script>